import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ORDER_CONTROL_KEY, OrderControlState } from '@usf/ngrx-order';

const selectOrderControlState =
  createFeatureSelector<OrderControlState>(ORDER_CONTROL_KEY);
export const selectOrderControl = createSelector(
  selectOrderControlState,
  (state: OrderControlState) => state.orderControl,
);
